import mergeClasses from '../utils/mergeClasses';

function Button({children, className, ...props}) {

  return (
    <button className={mergeClasses('m-2', className)} {...props} >{children}</button>
  );
}

function PrimaryButton({children, className, ...props}) {

  return (
    <Button className={mergeClasses('btn btn-primary', className)} {...props} >{children}</Button>
  );
}

function SecondaryButton({children, className, ...props}) {

  return (
    <Button className={mergeClasses('btn btn-secondary', className)} {...props} >{children}</Button>
  );
}

export default Button;
export { Button, PrimaryButton, SecondaryButton };